import './schedule.css'

/**
 * Тихая легенда над таблицей графика: вертикальный список мелким приглушённым текстом — что значат «Р», «В», «Н» и полоса выходного
 * столбца. Только текст и значки без кнопок; значки скрыты от диктора - слова рядом с ними видны и читаются. Про занятый на
 * другом объекте день отдельного пункта нет: такая клетка выглядит как не отмеченная, а причина показана подсказкой при наведении.
 */
export function Legend() {
  return (
    <ul className="sch-legend" aria-label="Обозначения таблицы">
      <li>
        <span className="sch-legend__box sch-legend__box--on" aria-hidden="true">
          Р
        </span>
        выходит
      </li>
      <li>
        <span className="sch-legend__box sch-legend__box--day-off" aria-hidden="true">
          В
        </span>
        выходной день
      </li>
      <li>
        <span className="sch-legend__box sch-legend__box--off" aria-hidden="true">
          Н
        </span>
        не выходит (или не отмечено)
      </li>
      <li>
        <span className="sch-legend__box sch-legend__box--weekend" aria-hidden="true" />
        суббота и воскресенье
      </li>
    </ul>
  )
}
